/**
 * uiReferenceContext.js — C4d-2 (01/09/2026): UI_REFERENCE_CONTEXT (raw).
 *
 * Deriva de forma CENTRAL e PURA o contexto de referência da tela atual a
 * partir do pathname — sem provider/registro por página (evita por
 * construção o problema de stale registration do FormBridge): a cada
 * sendAssistMessage o snapshot é recalculado da rota ATUAL (F6), navegar
 * não gera nenhuma chamada backend (F7) e sair da tela limpa a referência
 * automaticamente (F4).
 *
 * SEC-A: isto é HINT ("o que a interface diz estar visível"). O backend
 * re-resolve athlete_id contra o escopo do JWT (vw_staff_accessible_athletes)
 * e só o RESOLVED chega ao agente. Nunca enviar: club_id, user_id, role,
 * permissions, nomes como autoridade, estado do Builder ou dados de wellness
 * — todos têm fontes canônicas próprias.
 *
 * Surfaces = whitelist espelhada do backend (ui_reference.py).
 */

// [regex da rota, surface, extrai athlete_id?]
const SURFACE_RULES = [
  [/^\/coach\/athlete\/(\d+)/, 'athlete_detail', true],
  [/^\/coach\/training\/execute\//, 'training_execution', false],
  [/^\/coach\/training/, 'coach_training', false],
  [/^\/coach\/groups/, 'squads', false],
  [/^\/coach\/performance/, 'coach_performance', false],
  [/^\/coach\/?$/, 'dashboard', false],
];

/**
 * pathname → raw UI_REFERENCE_CONTEXT ou null (nenhuma surface conhecida).
 * @param {string} pathname — ex.: "/coach/athlete/65"
 * @returns {{surface: string, references?: {athlete_id: number}}|null}
 */
export function buildUiReferenceContext(pathname) {
  const path = String(pathname || '');
  for (const [re, surface, hasAthlete] of SURFACE_RULES) {
    const m = re.exec(path);
    if (m) {
      const ctx = { surface };
      if (hasAthlete) {
        const id = parseInt(m[1], 10);
        if (Number.isFinite(id) && id > 0) ctx.references = { athlete_id: id };
      }
      return ctx;
    }
  }
  return null;
}
